import React, { useRef, useState } from "react";
import HTMLFlipBook from "react-pageflip";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Helmet } from "react-helmet-async";

const pages = [
  "/champaran/page1.jpg",
  "/champaran/page2.jpg",
  "/champaran/page3.jpg",
  "/champaran/page4.jpg",
  "/champaran/page5.jpg",
  "/champaran/page6.jpg",
  "/champaran/page7.jpg",
  "/champaran/page8.jpg",
  "/champaran/page9.jpg",
  "/champaran/page10.jpg",
  "/champaran/page11.jpg",
  "/champaran/page12.jpg",
  "/champaran/page13.jpg",
  "/champaran/page14.jpg",
  "/champaran/page15.jpg",
  "/champaran/page16.jpg",
  "/champaran/page17.jpg",
  "/champaran/page18.jpg",
  "/champaran/page19.jpg",
];

export default function Champaran() {
  const book = useRef(null);
  const [page, setPage] = useState(1);

  const nextPage = () => {
    book.current?.pageFlip().flipNext();
  };

  const prevPage = () => {
    book.current?.pageFlip().flipPrev();
  };

  return (
    <>
      <Helmet>
        <title>Champaran | Gandhi Mandela Foundation</title>
        <meta name="description" content="Champaran" />
      </Helmet>
      <Header />

      <section className="page-header">
        <div className="container">
          <div className="breadcrumb">
            <a href="/">Home</a>
            <span>/</span>
            <span>Champaran</span>
          </div>
          <h1>Champaran</h1>
        </div>
      </section>

      <section className="section">
        <div className="container flipbook-container">

          <HTMLFlipBook
            ref={book}
            width={600}
            height={600}
            size="stretch"
            minWidth={280}
            maxWidth={700}
            minHeight={500}
            maxHeight={900}
            showCover={true}
            mobileScrollSupport={true}
            drawShadow={true}
            onFlip={(e) => setPage(e.data + 1)}
          >
            {pages.map((img, index) => (
              <div className="book-page" key={index}>
                <img src={img} alt={`Page ${index + 1}`} />

                {/* Top Right Corner */}
                <div className="page-corner top">
                  <i className="fa-solid fa-hand-pointer"></i>
                </div>

                {/* Bottom Right Corner */}
                <div className="page-corner bottom">
                  <i className="fa-solid fa-hand-pointer"></i>
                </div>
              </div>
            ))}
          </HTMLFlipBook>

          {/* Page Number */}
          <div className="page-count">
            Page {page} of {pages.length}
          </div>

          {/* Swipe Hint */}
          <div className="swipe-hint">
            <i className="fa-solid fa-hand-point-up"></i>
            Swipe or use the buttons below to turn pages
          </div>

          {/* Mobile Buttons */}
          <div className="mobile-controls">
            <button onClick={prevPage}>
              <i className="fa-solid fa-chevron-left"></i> Previous
            </button>

            <button onClick={nextPage}>
              Next <i className="fa-solid fa-chevron-right"></i>
            </button>
          </div>

        </div>
      </section>

      <Footer />
    </>
  );
}